import type { App } from '@grafikr/components';

import intersectionLoader from 'utils/loaders/intersection';
import onEvent from 'utils/loaders/on-event';
import onElementInteraction from 'utils/loaders/on-element-interaction';
import hasUrlParam from 'utils/loaders/has-url-param';

import header from 'layout/header';

export default (app: App) => {
  app.add({
    // Layout
    header,

    // Components
    video: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-video" */ 'components/video'),
    ],
    countdown: [
      intersectionLoader,
      () => import(/* webpackChunkName: "countdown" */ 'components/countdown'),
    ],
    faq: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-faq" */ 'components/faq'),
    ],
    accordion: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-accordion" */ 'components/accordion'),
    ],
    'size-guide': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-size-guide" */ 'components/size-guide'),
    ],
    'search-drawer': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-search-drawer" */ 'components/search-drawer'),
    ],
    'mobile-menu': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-mobile-menu" */ 'components/mobile-menu'),
    ],
    'address-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-address-form" */ 'components/address-form'),
    ],
    'share-modal': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-share-modal" */ 'components/share-modal'),
    ],
    'cart-drawer': [
      [onEvent, onElementInteraction, hasUrlParam],
      () => import(/* webpackChunkName: "component-cart-drawer" */ 'components/cart-drawer'),
    ],
    'brand-drawer': [
      [onEvent, onElementInteraction],
      () => import(/* webpackChunkName: "component-brand-drawer" */ 'components/brand-drawer'),
    ],
    copy: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-copy" */ 'components/copy'),
    ],
    'recently-viewed': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "component-recently-viewed" */ 'components/recently-viewed'),
    ],
    slider: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-slider" */ 'components/slider'),
    ],
    'lazy-content': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-lazy-content" */ 'components/lazy-content'),
    ],

    // Pages
    'search-page': [
      intersectionLoader,
      () => import(/* webpackChunkName: "search-page" */ 'pages/search/main'),
    ],
    'collection-filter': [
      intersectionLoader,
      () => import(/* webpackChunkName: "collection-filter" */ 'pages/collection/filter'),
    ],
    product: [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-main" */ 'pages/product/main'),
    ],
    'product-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-form" */ 'pages/product/form'),
    ],
    'product-images': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-images" */ 'pages/product/images'),
    ],
    'product-recommendations': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "product-recommendations" */ 'pages/product/recommendations'),
    ],
    wishlist: [
      intersectionLoader,
      () => import(/* webpackChunkName: "wishlist" */ 'pages/wishlist/main'),
    ],
  });
};
